import { FOLLOW_UP_QUESTION_TYPE, FOLLOW_UP_QUESTION_TYPE_MAP } from '../../../constants';
import { IQuestionTypeProps } from './question-types-props';
import './question-type-viewer.scss';


const QuestionTypeViewer: React.FC<IQuestionTypeProps> = ({ question, disabled, validationGroup }) => {
    const Component = FOLLOW_UP_QUESTION_TYPE_MAP[question?.type as FOLLOW_UP_QUESTION_TYPE]?.component;
    
    if (!question) {
        return null;
    }
    
    return (
        <div className={`answer-viewer ${disabled ? 'disabled' : ''}`}>
            {
                Component && <Component question={question} disabled={disabled} validationGroup={validationGroup} />
            }
        </div>
    )
}

export default QuestionTypeViewer;
